// src/locales/ta/products.js
export const products = {
  // Page titles and navigation
  createNewProduct: 'புதிய தயாரிப்பு உருவாக்கவும்',
  addNewProductToInventory: 'உங்கள் இருப்புக்கு புதிய தயாரிப்பைச் சேர்க்கவும்',
  backToProducts: 'தயாரிப்புகளுக்குத் திரும்பு',
  allProducts: 'அனைத்து தயாரிப்புகள்',
  addProduct: 'தயாரிப்பு சேர்க்கவும்',
  editProduct: 'தயாரிப்பு திருத்தவும்',
  deleteProduct: 'தயாரிப்பு நீக்கவும்',
  duplicateProduct: 'தயாரிப்பு நகல் எடுக்கவும்',
  viewDetails: 'விவரங்களைக் காண்க',
  
  // Product list page
  manageProductInventory: 'உங்கள் தயாரிப்பு இருப்பு மற்றும் பட்டியலை நிர்வகிக்கவும்',
  loadingProducts: 'தயாரிப்புகள் ஏற்றப்படுகின்றன',
  loadingProductsDesc: 'உங்கள் தயாரிப்புகளை ஏற்றும் வரை காத்திருக்கவும்...',
  unableToLoadProducts: 'தயாரிப்புகளை ஏற்ற முடியவில்லை',
  noProductsFound: 'தயாரிப்புகள் கிடைக்கவில்லை',
  noProductsFoundDesc: 'உங்கள் தற்போதைய தேடல் மற்றும் வடிகட்டி அளவுகோல்களுக்கு பொருந்தும் தயாரிப்புகள் இல்லை.',
  noProductsYet: 'இன்னும் தயாரிப்புகள் இல்லை',
  noProductsYetDesc: 'உங்கள் முதல் தயாரிப்பைச் சேர்ப்பதன் மூலம் உங்கள் இருப்பை உருவாக்கத் தொடங்குங்கள்.',
  addFirstProduct: 'முதல் தயாரிப்பைச் சேர்க்கவும்',
  priceOptions: 'விலை விருப்பங்கள்',
  range: 'வரம்பு',
  noPrice: 'விலை இல்லை',
  multiplePrices: 'பல விலைகள்',
  priceRange: 'விலை வரம்பு',
  lowestPrice: 'குறைந்த விலை',
  highestPrice: 'அதிக விலை',
  startingFrom: 'இருந்து',
  upTo: 'வரை',
  
  // Product list filters
  allTypes: 'அனைத்து வகைகள்',
  allVisibility: 'அனைத்து தெரிவுநிலை',
  allStatus: 'அனைத்து நிலை',
  allCategories: 'அனைத்து வகைகள்',
  
  // Product list table headers
  productDetails: 'தயாரிப்பு விவரங்கள்',
  noCategories: 'வகைகள் இல்லை',
  
  // Product list pagination
  show: 'காட்டு',
  perPage: 'ஒரு பக்கத்திற்கு',
  showingRecords: '{{total}} இல் {{start}} முதல் {{end}} வரை காட்டப்படுகிறது',
  firstPage: 'முதல் பக்கம்',
  previousPage: 'முந்தைய பக்கம்',
  nextPage: 'அடுத்த பக்கம்',
  lastPage: 'கடைசி பக்கம்',
  
  // Product actions and confirmations
  confirmStatusChange: '"{{productName}}" என்பதை {{action}} செய்ய விரும்புகிறீர்களா?',
  confirmDuplicate: '"{{productName}}" நகல் எடுக்க விரும்புகிறீர்களா?',
  confirmDelete: '"{{productName}}" நீக்க விரும்புகிறீர்களா? இந்த செயலை மாற்ற முடியாது.',
  statusUpdateSuccess: '"{{productName}}" வெற்றிகரமாக {{status}} ஆக அமைக்கப்பட்டது!',
  statusUpdateFailed: 'தயாரிப்பு நிலையை புதுப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
  duplicateSuccess: '"{{productName}}" வெற்றிகரமாக நகல் எடுக்கப்பட்டது!',
  duplicateFailed: 'தயாரிப்பு நகல் எடுக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
  deleteSuccess: '"{{productName}}" வெற்றிகரமாக நீக்கப்பட்டது!',
  deleteFailed: 'தயாரிப்பு நீக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
  
  // Product status actions
  makeDraft: 'வரைவு செய்யவும்',
  makePublic: 'பொது செய்யவும்',
  
  // Loading states
  loadingData: 'தரவு ஏற்றப்படுகிறது',
  loadingDataDesc: 'தேவையான தரவு ஏற்றப்படும் வரை காத்திருக்கவும்...',
  failedToLoadData: 'தேவையான தரவை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
  
  // Form tabs
  basicInfo: 'அடிப்படை தகவல்',
  pricing: 'விலை & இருப்பு',
  pricingInfo: 'விலை தகவல்',
  pricingInfoDesc: 'விலை மற்றும் கடை-குறிப்பிட்ட தகவலை அமைக்கவும்',
  images: 'படங்கள்',
  variations: 'மாறுபாடுகள்',
  
  // Basic Information
  basicInformation: 'அடிப்படை தகவல்',
  basicInformationDesc: 'உங்கள் தயாரிப்பு பற்றிய அடிப்படை விவரங்களை உள்ளிடவும்',
  basicInformationEditDesc: 'உங்கள் தயாரிப்பு பற்றிய அடிப்படை விவரங்களை புதுப்பிக்கவும்',
  productName: 'தயாரிப்பு பெயர்',
  productNamePlaceholder: 'தயாரிப்பு பெயரை உள்ளிடவும்',
  printableName: 'அச்சிடும் பெயர்',
  printableNamePlaceholder: 'waybill-இல் அச்சிட வேண்டிய பெயர் (viruppam)',
  printableNameHint: 'அமைக்கப்பட்டால், தயாரிப்பு பெயருக்குப் பதிலாக இந்தப் பெயர் waybill label-இல் அச்சிடப்படும்',
  nameRequired: 'தயாரிப்பு பெயர் தேவை',
  
  productType: 'தயாரிப்பு வகை',
  productTypeShort: 'வகை',
  productTypeRequired: 'தயாரிப்பு வகை தேவை',
  simpleProduct: 'எளிய தயாரிப்பு',
  variableProduct: 'மாறும் தயாரிப்பு (மாறுபாடுகளுடன்)',
  simpleProductShort: 'எளிய',
  variableProductShort: 'மாறும்',

  
  description: 'விவரம்',
  descriptionPlaceholder: 'தயாரிப்பு விவரத்தை உள்ளிடவும் (விருப்பம்)',
  
  visibility: 'தெரிவுநிலை',
  visibilityRequired: 'தெரிவுநிலை தேவை',
  public: 'பொது',
  draft: 'வரைவு',
  trash: 'குப்பை',
  
  brand: 'பிராண்ட்',
  selectBrand: 'பிராண்ட் தேர்ந்தெடுக்கவும் (விருப்பம்)',
  
  // Categories and Tags
  categories: 'தயாரிப்பு வகைகள்',
  categoriesShort: 'வகைகள்',
  categoryRequired: 'தயவுசெய்து ஒரு வகையைத் தேர்ந்தெடுக்கவும்',
  chooseCategory: 'தயாரிப்பு வகையைத் தேர்வு செய்யவும்',
  
  tags: 'குறிச்சொற்கள்',
  selectTags: 'குறிச்சொற்களைத் தேர்ந்தெடுக்கவும்',
  searchTags: 'குறிச்சொற்களைத் தேடவும்...',
  noTagsFound: 'குறிச்சொற்கள் கிடைக்கவில்லை',
  noTagsAvailable: 'குறிச்சொற்கள் கிடைக்கவில்லை',
  loadingTags: 'குறிச்சொற்கள் ஏற்றப்படுகின்றன...',
  productTags: 'தயாரிப்பு குறிச்சொற்கள்',
  selectProductTags: 'தயாரிப்பு குறிச்சொற்களைத் தேர்ந்தெடுக்கவும்',
  tagsSelected: '{{count}} குறிச்சொற்கள் தேர்ந்தெடுக்கப்பட்டன',
  removeTag: 'குறிச்சொல் நீக்கவும்',
  
  // Pricing and Inventory
  pricingInventory: 'விலை & இருப்பு',
  pricingInventoryDesc: 'விலை, இருப்பு மற்றும் தயாரிப்பு பரிமாணங்களை அமைக்கவும்',
  basicPricingInfo: 'அடிப்படை விலை தகவல்',
  basicPricingInfoDesc: 'அடிப்படை விலை விவரங்களை அமைக்கவும். கடை விலை மற்றும் இருப்பு மாறுபாட்டின்படி கட்டமைக்கப்படும்.',
  
  buyingPrice: 'வாங்கும்/செலவு விலை',
  barcode: 'பார்கோடு',
  barcodePlaceholder: 'தயாரிப்பு பார்கோடை உள்ளிடவும் (விருப்பம்)',
  
  weight: 'எடை',
  length: 'நீளம்', 
  width: 'அகலம்',
  height: 'உயரம்',
  
  shopPricingInventory: 'கடை-குறிப்பிட்ட விலை',
  shopPricingInventoryDesc: 'ஒவ்வொரு கடைக்கும் வெவ்வேறு விலைகள் மற்றும் சரக்கு நிலைகளை அமைக்கவும்',
  shopPricingInventoryDescSelect: 'கடைகளைத் தேர்ந்தெடுத்து ஒவ்வொரு கடைக்கும் விலையை அமைக்கவும்',
  shopPricing: 'கடை விலை',
  shopPricingDesc: 'இந்த தயாரிப்பு விற்கப்படும் ஒவ்வொரு கடைக்கும் விலையை அமைக்கவும்',
  salesPrice: 'விற்பனை விலை',
  salesPriceRequired: 'விற்பனை விலை தேவை',
  dropshippingPrice: 'நேரடி அனுப்பு விலை',
  dropshippingPriceRequired: 'நேரடி அனுப்பு கடைகளுக்கு நேரடி அனுப்பு விலை தேவை',
  dropshipperPricing: 'நேரடி அனுப்பு விலை',
  stock: 'சரக்கு',
  stockRequired: 'சரக்கு அளவு தேவை',
  
  // Opening Stock
  openingStock: 'தொடக்க சரக்கு',
  openingStockDesc: 'ஒவ்வொரு கிடங்கிற்கும் தொடக்க சரக்கு அளவை அமைக்கவும்',
  warehouseStock: 'கிடங்கு சரக்கு',
  openingStockRequired: 'தொடக்க சரக்கு தேவை',
  openingStockMinimum: 'தொடக்க சரக்கு 0 அல்லது அதிகமாக இருக்க வேண்டும்',
  
  // Variations
  productVariations: 'தயாரிப்பு மாறுபாடுகள்',
  productVariationsDesc: 'ஒவ்வொரு மாறுபாட்டிற்கும் விலை மற்றும் இருப்பை கட்டமைக்கவும்',
  productVariationsDescFull: 'ஒவ்வொரு மாறுபாட்டிற்கும் விலை மற்றும் இருப்பை கட்டமைக்கவும். ஒவ்வொரு மாறுபாட்டிற்கும் கடைகள் முழுவதும் வெவ்வேறு விலைகள் மற்றும் கிடங்குகளில் வெவ்வேறு சரக்கு நிலைகள் இருக்கலாம்.',
  variation: 'மாறுபாடு',
  sku: 'SKU',
  skuPlaceholder: 'SKU உள்ளிடவும் (விருப்பம்)',
  skuVariationPlaceholder: 'மாறுபாடு SKU உள்ளிடவும்',
  price: 'விலை',
  variationPriceRequired: 'மாறுபாடு விலை தேவை',
  variationStockRequired: 'மாறுபாடு சரக்கு தேவை',
  costPrice: 'செலவு விலை',
  variationImage: 'மாறுபாடு படம்',
  editModeVariationsNote: 'மாறுபாடுகளில் செய்யப்படும் மாற்றங்கள் தற்போதுள்ள ID மற்றும் உறவுகளை பாதுகாக்கும்.',
  
  // Variations UI
  variationsGenerated: '{{count}} மாறுபாடுகள் உருவாக்கப்பட்டன',
  configureVariations: 'கீழே ஒவ்வொரு மாறுபாட்டையும் கட்டமைக்கவும்:',
  regenerate: 'மீண்டும் உருவாக்கவும்',
  removeSelected: 'தேர்ந்தெடுத்தவற்றை நீக்கவும் ({{count}})',
  bulkActions: 'மொத்த செயல்கள்',
  variationsSelected: '{{total}} இல் {{selected}} தேர்ந்தெடுக்கப்பட்டது',
  variationNumber: 'மாறுபாடு #{{number}}',
  expand: 'விரிவாக்கவும்',
  collapse: 'சுருக்கவும்',
  edit: 'திருத்தவும்',
  
  // Bulk Actions
  bulkActionsTitle: 'மொத்த செயல்கள்',
  bulkActionsDesc: 'தேர்ந்தெடுக்கப்பட்ட {{count}} மாறுபாடுகளுக்கு மாற்றங்களைப் பயன்படுத்தவும்',
  shopAssignments: 'கடை ஒதுக்கீடுகள்',
  basicFields: 'அடிப்படை புலங்கள்',
  cancel: 'ரத்து செய்',
  applyToSelected: 'தேர்ந்தெடுத்தவற்றுக்குப் பயன்படுத்து',
  bulkActionsApplied: 'மொத்த செயல்கள் வெற்றிகரமாக பயன்படுத்தப்பட்டன',
  bulkActionsError: 'மொத்த செயல்களைப் பயன்படுத்த மாறுபாடுகளைத் தேர்ந்தெடுக்கவும்',
  productsSelected: '{{count}} தயாரிப்புகள் தேர்ந்தெடுக்கப்பட்டன',
  deleteSelected: 'தேர்ந்தெடுத்தவற்றை நீக்கவும் ({{count}})',
  confirmBulkDelete: '{{count}} தயாரிப்புகளை நீக்க விரும்புகிறீர்களா? இந்த செயலை மாற்ற முடியாது.',
  bulkDeleteSuccess: '{{count}} தயாரிப்புகள் வெற்றிகரமாக நீக்கப்பட்டன!',
  bulkDeleteFailed: 'சில தயாரிப்புகளை நீக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
  
  // Variations Validation
  noVariationsAvailable: 'மாறுபாடுகள் கிடைக்கவில்லை',
  noVariationsMessage: 'மாறுபாடுகளை உருவாக்க, தயவுசெய்து:',
  goToAttributesStep1: 'செல்லவும்',
  goToAttributesStep2: 'தாவலுக்கு',
  goToAttributesStep3: 'தயாரிப்பு பண்புக்கூறுகளைச் சேர்க்கவும்',
  goToAttributesStep4: 'பண்புக்கூறு மதிப்புகளைத் தேர்ந்தெடுக்கவும்',
  goToAttributesStep5: 'நீங்கள் பயன்படுத்த விரும்பும் பண்புக்கூறுகளுக்கு "மாறுபாடுகளுக்கு பயன்படுத்தப்பட்டது" இயக்கவும்',
  goToAttributes: 'பண்புக்கூறுகளுக்குச் செல்லவும்',
  noVariationsGenerated: 'மாறுபாடுகள் உருவாக்கப்படவில்லை',
  noVariationsGeneratedDesc: 'உங்கள் பண்புக்கூறு தேர்வுகளின் அடிப்படையில் மாறுபாடுகள் தானாக உருவாக்கப்படும்.',
  atLeastOneVariationRequired: 'குறைந்தபட்சம் ஒரு மாறுபாடு தேவை',
  atLeastOneShopRequired: 'விற்பனை விலையுடன் குறைந்தபட்சம் ஒரு கடை இயக்கப்பட வேண்டும்',
  skuValidationInProgress: 'SKU சரிபார்ப்பு செயலில் உள்ளது...',
  skuAlreadyInUse: 'இந்த SKU ஏற்கனவே பயன்பாட்டில் உள்ளது',
  
  // Attributes
  attributes: 'தயாரிப்பு பண்புக்கூறுகள்',
  selectAttributes: 'பண்புக்கூறுகளைத் தேர்ந்தெடுக்கவும்',
  attributesRequiredForVariable: 'மாறும் தயாரிப்புகளுக்கு குறைந்தபட்சம் ஒரு பண்புக்கூறு தேவை',
  attributesVariableDesc: 'தேர்ந்தெடுக்கப்பட்ட பண்புக்கூறுகள் தயாரிப்பு மாறுபாடுகளை உருவாக்க பயன்படுத்தப்படும்',
  attributesDesc: 'இந்த தயாரிப்புக்கு பொருந்தும் பண்புக்கூறுகளைத் தேர்ந்தெடுக்கவும்',
  attributesVariableEditDesc: 'தேர்ந்தெடுக்கப்பட்ட பண்புக்கூறுகள் தயாரிப்பு மாறுபாடுகளை உருவாக்க பயன்படுத்தப்படும். மாற்றங்கள் தற்போதுள்ள மாறுபாடுகளை பாதிக்கும்.',
  attributesEditDesc: 'இந்த தயாரிப்பை விவரிக்கும் பண்புக்கூறுகளைத் தேர்ந்தெடுக்கவும்.',
  variableProductAttributesRequired: 'மாறுபாடுகளுக்கு மாறும் தயாரிப்புகளுக்கு குறைந்தபட்சம் ஒரு பண்புக்கூறு தேவை.',
  variationAttributesInfo: '"மாறுபாடுகளுக்கு பயன்படுத்தப்பட்டது" என குறிக்கப்பட்ட பண்புக்கூறுகள் தயாரிப்பு மாறுபாடுகளை உருவாக்கும்.',
  variationAttributesInfo2: 'நீங்கள் தேவைப்படும் மாறுபாடுகளை உருவாக்க பண்புக்கூறு மதிப்புகளைத் தேர்ந்தெடுக்க உறுதி செய்யவும்.',
  changesWillUpdateVariations: 'பண்புக்கூறுகளில் செய்யப்படும் மாற்றங்கள் தற்போதுள்ள தயாரிப்பு மாறுபாடுகளை பாதிக்கலாம்.',
  
  // Images
  productImages: 'தயாரிப்பு படங்கள்',
  productImagesDesc: 'உங்கள் தயாரிப்பைக் காட்ட படங்களைப் பதிவேற்றவும்',
  productImagesRecommendation: 'தயாரிப்பு படங்களுக்கான உங்கள் பரிந்துரைகளைப் பதிவேற்றவும்.',
  editModeImageNote: 'தற்போதுள்ள படங்களை மாற்ற அல்லது புதிதாக சேர்க்க முடியும். தயாரிப்பை புதுப்பிக்கும்போது மாற்றங்கள் சேமிக்கப்படும்.',
  editModeInstructions: 'தற்போதுள்ள படங்களை கிளிக் செய்து மாற்றவும், அல்லது வெற்று இடங்களில் புதிய படங்களைச் சேர்க்கவும்.',
  
  mainImage: 'முக்கிய தயாரிப்பு படம்',
  uploadMainImage: 'முக்கிய படத்தைப் பதிவேற்றவும்',
  uploadImages: 'படங்களைப் பதிவேற்றவும்',
  clickToUploadMainImage: 'முக்கிய படத்தைப் பதிவேற்ற கிளிக் செய்யவும்',
  imageFormats: 'PNG, JPG, JPEG, WEBP 5MB வரை',
  invalidImageFormat: 'தவறான படம் வடிவம். தயவுசெய்து PNG, JPG, JPEG அல்லது WEBP பயன்படுத்தவும்',
  imageTooLarge: 'படம் கோப்பு மிகப் பெரியது. அதிகபட்ச அளவு 5MB',
  
  galleryImages: 'கேலரி படங்கள்',
  galleryImagesDesc: 'வெவ்வேறு கோணங்கள் அல்லது அம்சங்களைக் காட்ட கூடுதல் படங்களைப் பதிவேற்றவும்',
  addGalleryImages: 'கேலரி படங்களைச் சேர்க்கவும்',
  invalidGalleryImages: 'ஒன்று அல்லது அதற்கு மேற்பட்ட கேலரி படங்கள் தவறானவை அல்லது மிகப் பெரியவை',
  setAsMainImage: 'முக்கிய படமாக அமைக்கவும்',
  replaceImage: 'படத்தை மாற்றவும்',
  revertImage: 'படத்தை மீட்டமைக்கவும்',
  removeImage: 'படத்தை நீக்கவும்',
  mainImageBadge: 'முக்கிய',
  modified: 'மாற்றப்பட்டது',
  dragDropInstructions: 'பதிவேற்ற இழுத்து விடவும் அல்லது கோப்புகளைத் தேர்ந்தெடுக்கவும்.',
  maxImagesNote: 'அதிகபட்சம் {{max}} படங்கள் அனுமதிக்கப்படுகின்றன.',
  
  // Form actions
  createProduct: 'தயாரிப்பு உருவாக்கவும்',
  updateProduct: 'தயாரிப்பு புதுப்பிக்கவும்',
  productCreatedSuccess: 'தயாரிப்பு "{{productName}}" வெற்றிகரமாக உருவாக்கப்பட்டது!',
  productUpdated: 'தயாரிப்பு வெற்றிகரமாக புதுப்பிக்கப்பட்டது',
  failedToCreateProduct: 'தயாரிப்பு உருவாக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
  failedToUpdateProduct: 'தயாரிப்பு புதுப்பிக்க முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
  failedToLoadProduct: 'தயாரிப்பை ஏற்ற முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.',
  
  // Common terms used throughout
  required: 'தேவை',
  optional: 'விருப்பம்',
  selectOption: 'ஒரு விருப்பத்தைத் தேர்ந்தெடுக்கவும்',
  
  // Error messages
  someFieldsRequired: 'தயவுசெய்து அனைத்து தேவையான புலங்களையும் நிரப்பவும்',
  invalidPriceValue: 'தயவுசெய்து சரியான விலையை உள்ளிடவும்',
  invalidStockValue: 'தயவுசெய்து சரியான சரக்கு அளவை உள்ளிடவும்',
  stockMinZero: 'சரக்கு 0 அல்லது அதிகமாக இருக்க வேண்டும்',
  salesPriceRequiredEnabled: 'இயக்கப்பட்ட கடைகளுக்கு விற்பனை விலை தேவை',
  
  // Success messages
  productSaved: 'தயாரிப்பு வெற்றிகரமாக சேமிக்கப்பட்டது',
  productDeleted: 'தயாரிப்பு வெற்றிகரமாக நீக்கப்பட்டது',
  
  // Validation messages
  priceMinimum: 'விலை 0 க்கு அதிகமாக இருக்க வேண்டும்',
  stockMinimum: 'சரக்கு 0 அல்லது அதிகமாக இருக்க வேண்டும்',
  weightMinimum: 'எடை 0 க்கு அதிகமாக இருக்க வேண்டும்',
  dimensionMinimum: 'பரிமாணங்கள் 0 க்கு அதிகமாக இருக்க வேண்டும்',
  
  // Product status labels
  active: 'செயலில்',
  inactive: 'செயலற்றது',
  inStock: 'சரக்கில்',
  outOfStock: 'சரக்கு இல்லை',
  lowStock: 'குறைந்த சரக்கு',
  
  // Shop integration
  availableInShops: 'கடைகளில் கிடைக்கும்',
  notAvailableInAnyShop: 'இந்த தயாரிப்பு எந்த கடையிலும் கிடைக்கவில்லை',
  shopSpecificPricing: 'கடை-குறிப்பிட்ட விலை இயக்கப்பட்டது',
  
  // Attribute and variation helpers
  noAttributesSelected: 'பண்புக்கூறுகள் தேர்ந்தெடுக்கப்படவில்லை',
  variationsWillBeGenerated: 'தேர்ந்தெடுக்கப்பட்ட பண்புக்கூறுகளின் அடிப்படையில் மாறுபாடுகள் தானாக உருவாக்கப்படும்',
  variationCount: '{{count}} மாறுபாடுகள் உருவாக்கப்படும்',
  
  // Image upload helpers
  dragDropImages: 'படங்களை இங்கே இழுத்து விடவும், அல்லது தேர்ந்தெடுக்க கிளிக் செய்யவும்',
  imageUploadProgress: 'படங்கள் பதிவேற்றப்படுகின்றன...',
  imageUploadComplete: 'படங்கள் வெற்றிகரமாக பதிவேற்றப்பட்டன',
  imageUploadFailed: 'சில படங்களைப் பதிவேற்ற முடியவில்லை',
  
  // Bulk actions (for future use)
  selectAll: 'அனைத்தையும் தேர்ந்தெடுக்கவும்',
  deselectAll: 'அனைத்து தேர்வையும் நீக்கவும்',
  bulkEdit: 'மொத்த திருத்தம்',
  bulkDelete: 'மொத்த நீக்கம்',
  
  // Filters and search
  searchProducts: 'தயாரிப்புகளைத் தேடவும்...',
  filterByCategory: 'வகையின்படி வடிகட்டவும்',
  filterByBrand: 'பிராண்டின்படி வடிகட்டவும்',
  filterByStatus: 'நிலையின்படி வடிகட்டவும்',
  sortByName: 'பெயரின்படி வரிசைப்படுத்து',
  sortByPrice: 'விலையின்படி வரிசைப்படுத்து',
  sortByStock: 'சரக்கின்படி வரிசைப்படுத்து',
  sortByDate: 'தேதியின்படி வரிசைப்படுத்து',
  
  // General information
  generalInformation: 'பொது தகவல்',
  pricingInformation: 'விலை தகவல்',
  inventoryInformation: 'இருப்பு தகவல்',
  shippingInformation: 'கப்பல் தகவல்',
  
  // Import/Export (for future features)
  importProducts: 'தயாரிப்புகள் இறக்குமதி',
  exportProducts: 'தயாரிப்புகள் ஏற்றுமதி',
  downloadTemplate: 'வார்ப்புரு பதிவிறக்கவும்',
  uploadFile: 'கோப்பு பதிவேற்றவும்',

  // Bulk Import
  bulkImportProducts: 'மொத்த இறக்குமதி',
  bulkImportProductsTitle: 'தயாரிப்புகளை மொத்தமாக இறக்குமதி செய்யவும்',
  bulkImportProductsDesc: 'ஒரே நேரத்தில் பல தயாரிப்புகளை உருவாக்க அல்லது புதுப்பிக்க Excel தாளைப் பதிவேற்றவும்',
  columnMapping: 'நெடுவரிசை மேப்பிங்',
  selectShopsStep: 'கடைகளைத் தேர்ந்தெடுக்கவும்',
  uploadFileStep: 'கோப்பு பதிவேற்றவும்',
  validateProducts: 'தயாரிப்புகளை சரிபார்க்கவும்',
  submitProducts: 'தயாரிப்புகளை சமர்ப்பிக்கவும்',
  submitValidProducts: 'சரியான தயாரிப்புகள் {{count}} சமர்ப்பிக்கவும்',
  clearAll: 'அனைத்தையும் அழிக்கவும்',
  retryValidation: 'மீண்டும் சரிபார்க்கவும்',
  importComplete: 'இறக்குமதி முடிந்தது!',
  successfullyImported: 'வெற்றிகரமாக இறக்குமதி செய்யப்பட்டது',
  importMoreProducts: 'மேலும் தயாரிப்புகளை இறக்குமதி செய்யவும்',
  viewProducts: 'தயாரிப்புகளைப் பார்க்கவும்',
  failedRows: 'தோல்வியடைந்த வரிசைகள்:',
  validRows: 'சரியான வரிசைகள்',
  invalidRows: 'தவறான வரிசைகள்',
  totalRows: 'மொத்த வரிசைகள்',
  totalSubmitted: 'மொத்தம் சமர்ப்பிக்கப்பட்டது',
  validationResults: 'சரிபார்ப்பு முடிவுகள்',

  // Advanced features
  enableTracking: 'இருப்பு கண்காணிப்பை இயக்கவும்',
  trackingEnabled: 'இந்த தயாரிப்புக்கு இருப்பு கண்காணிப்பு இயக்கப்பட்டுள்ளது',
  trackingDisabled: 'இந்த தயாரிப்புக்கு இருப்பு கண்காணிப்பு முடக்கப்பட்டுள்ளது',
  
  digitalProduct: 'டிஜிட்டல் தயாரிப்பு',
  physicalProduct: 'இயற்பியல் தயாரிப்பு',
  downloadableProduct: 'பதிவிறக்கக்கூடிய தயாரிப்பு',
  
  // SEO and marketing
  seoTitle: 'SEO தலைப்பு',
  seoDescription: 'SEO விவரம்',
  metaKeywords: 'மெட்டா முக்கிய வார்த்தைகள்',
  
  // Related products
  relatedProducts: 'தொடர்புடைய தயாரிப்புகள்',
  crossSells: 'குறுக்கு விற்பனை தயாரிப்புகள்',
  upSells: 'மேல் விற்பனை தயாரிப்புகள்',
  
  // Reviews and ratings
  customerReviews: 'வாடிக்கையாளர் விமர்சனங்கள்',
  averageRating: 'சராசரி மதிப்பீடு',
  totalReviews: 'மொத்த விமர்சனங்கள்',
  
  // Inventory alerts
  lowStockAlert: 'குறைந்த சரக்கு எச்சரிக்கை',
  outOfStockAlert: 'சரக்கு இல்லை எச்சரிக்கை',
  setAlertThreshold: 'எச்சரிக்கை வரம்பை அமைக்கவும்',
  
  // Product history
  productHistory: 'தயாரிப்பு வரலாறு',
  priceHistory: 'விலை வரலாறு',
  stockHistory: 'சரக்கு வரலாறு',
  lastUpdated: 'கடைசியாக புதுப்பிக்கப்பட்டது',
  createdDate: 'உருவாக்கிய தேதி',
  
  // Warnings and confirmations
  deleteProductWarning: 'இந்த தயாரிப்பை நீக்க விரும்புகிறீர்களா? இந்த செயலை மாற்ற முடியாது.',
  unsavedChanges: 'நீங்கள் சேமிக்கப்படாத மாற்றங்களைக் கொண்டுள்ளீர்கள். விட்டுச் செல்ல விரும்புகிறீர்களா?',
  discardChanges: 'மாற்றங்களை நிராகரி',
  saveChanges: 'மாற்றங்களைச் சேமி',
  
  // Form sections that might be added later
  advancedOptions: 'மேம்பட்ட விருப்பங்கள்',
  shippingSettings: 'கப்பல் அமைப்புகள்',
  taxSettings: 'வரி அமைப்புகள்',
  customFields: 'தனிப்பயன் புலங்கள்',
  
  // Product performance metrics
  totalSales: 'மொத்த விற்பனை',
  revenue: 'வருவாய்',
  profitMargin: 'லாப வரம்பு',
  popularityScore: 'பிரபலமான மதிப்பெண்',

  configureVariationsEdit: 'ஒவ்வொரு மாறுபாட்டிற்கும் விலை மற்றும் இருப்பை கட்டமைக்கவும். மாற்றங்கள் தற்போதுள்ள உறவுகளை பாதுகாக்கும்.',
  editModeStockNotice: 'சரக்கு அளவுகள் தனித்தனியாக நிர்வகிக்கப்படுகின்றன மற்றும் தயாரிப்பு திருத்தம் மூலம் புதுப்பிக்கப்படுவதில்லை.',
  currentImage: 'தற்போதைய படம்',
  newImage: 'புதிய படம்',
  currentImageWillBeDeleted: 'தற்போதைய படம் நீக்கப்படும்',
  undoDelete: 'செயல்தவிர்',
  chooseImageFile: 'இந்த மாறுபாட்டிற்கு பதிவேற்ற ஒரு படக் கோப்பைத் தேர்வு செய்யவும்',
  
  // Additional helpful translations
  existingVariation: 'தற்போதுள்ள மாறுபாடு',
  newVariation: 'புதிய மாறுபாடு',
  variationUpdated: 'புதுப்பிக்கப்பட்டது',
  variationCreated: 'புதிய',
  
  // Bulk actions translations
  applyingBulkActions: 'மொத்த செயல்களைப் பயன்படுத்துகிறது...',
  bulkActionsCompleted: 'மொத்த செயல்கள் வெற்றிகரமாக முடிந்தது',
  
  // Image management
  replaceCurrentImage: 'தற்போதைய படத்தை மாற்றவும்',
  uploadNewImage: 'புதிய படத்தைப் பதிவேற்றவும்',
  removeCurrentImage: 'தற்போதைய படத்தை நீக்கவும்',
  keepCurrentImage: 'தற்போதைய படத்தைத் தக்கவைக்கவும்',
  
  // Validation messages
  variationSkuInUse: 'இந்த மாறுபாடு SKU ஏற்கனவே பயன்பாட்டில் உள்ளது',
  validatingVariationSku: 'மாறுபாடு SKU சரிபார்க்கப்படுகிறது...',
  
  // Status indicators
  hasChanges: 'மாற்றங்கள் உள்ளன',
  noChanges: 'மாற்றங்கள் இல்லை',
  unsavedChanges: 'சேமிக்கப்படாத மாற்றங்கள்',

  // Quantity Offers
  manageOffers: 'சலுகைகளை நிர்வகி',
  offersTitle: 'அளவு-அடிப்படையிலான சலுகைகள்',
  addOffer: 'சலுகை சேர்',
  saveOffers: 'சலுகைகளை சேமி',
  noOffersYet: 'இன்னும் சலுகைகள் எதுவும் இல்லை',
  offerQuantity: 'அளவு',
  offerCriteria: 'நிபந்தனை',
  offerUnitPrice: 'அலகு விலை',
  offerDeliveryOverride: 'டெலிவரி கட்டணத்தை மேலெழுது',
  criteriaEqual: 'சமமான',
  criteriaGte: 'விட அதிகமாக அல்லது சமம்',

  // Bundle products
  bundleProduct: 'Bundle Product',
  bundleProductShort: 'Bundle',
  bundles: 'Bundles',
  bundleTab: 'Bundle',
  bundleComponents: 'Bundle Components',
  addComponent: 'Add Component',
  searchComponents: 'Search products to add...',
  componentQty: 'Qty',
  component: 'Component',
  unitValue: 'Unit Value',
  lineDiscount: 'Discount',
  lineTotal: 'Line Total',
  bundlePrice: 'Bundle Price',
  regularTotal: 'Regular Total',
  saving: 'Saving',
  free: 'FREE',
  componentNotAssigned: '{product} is not assigned to this shop',
  typeLocked: 'Bundle type cannot be changed after creation',
  itemsCount: '{count} items',
  noComponentsYet: 'No components added yet. Search above to add products.',
  bundleShopPricing: 'Shop Pricing',
  bulkSetValue: 'Set unit value',
  bulkSetDiscountAmount: 'Set discount amount',
  bulkSetDiscountPercent: 'Set discount %',
  bulkMakeFree: 'Make free (100%)',
  bulkFillFromShopPrice: 'Fill from shop price',
  bulkCopyShop: 'Copy from shop',
  copyFromShop: 'Source shop',
  applyBulk: 'Apply',
  selectedCount: '{count} selected',
  bundleComponentsRequired: 'Add at least one component to the bundle',
  bundleShopRequired: 'Enable at least one shop for the bundle',
  bundleQtyInvalid: 'Component quantity must be greater than 0',
  bundleValueInvalid: 'Unit value must be 0 or more',
  bundleDiscountInvalid: 'Discount must be between 0 and the line value',
  totalWeight: 'மொத்த எடை',
  availableStock: 'கிடைக்கும் இருப்பு',
  noSku: 'SKU இல்லை',
  notAssigned: 'ஒதுக்கப்படவில்லை',
  componentStock: 'கூறு இருப்பு',
};